/*
 * Gives the hero's video a way back out.
 *
 * DeferredMedia only ever loads: loadContent() appends the player, sets the
 * loaded attribute, and stops there. That is fine for a lightbox, which has its
 * own close, and fine for a video that sits in its own section. The hero's
 * player covers the section — the heading, the buttons, all of it — so without
 * this it is a one-way trip and the shopper never sees the call to action
 * again.
 *
 * A wrapper rather than a change to DeferredMedia itself: every other section's
 * deferred media is content that belongs where it lands, and none of them want
 * a close button.
 */
if (!customElements.get('hero-video')) {
  customElements.define(
    'hero-video',
    class HeroVideo extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('deferred-media');
        this.closeButton = this.querySelector('.hero__video-close');
        if (!this.media || !this.closeButton) return;

        this.closeButton.addEventListener('click', this.close.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.close();
        });
      }

      close() {
        // Removing the frame is what stops playback — a YouTube or Vimeo embed
        // carries on with its own sound otherwise, and there would be nothing
        // left on screen to pause it with.
        const player = this.media.querySelector('video, iframe');
        if (player) player.remove();

        // Clearing the attribute both restores the image and puts loadContent()
        // back in play, so the trigger works a second time.
        this.media.removeAttribute('loaded');

        const trigger = this.media.querySelector('.hero__video-trigger');
        if (trigger) trigger.focus();
      }
    }
  );
}
